import { format } from 'date-fns';

export type SubscriptionStatusBadgeVariant = 'success' | 'warning' | 'danger' | 'default';

export function subscriptionStatusBadgeVariant(status: string): SubscriptionStatusBadgeVariant {
  switch (status.toLowerCase()) {
    case 'active':
      return 'success';
    case 'trialing':
    case 'past_due':
      return 'warning';
    case 'canceled':
    case 'paused':
    case 'inactive':
    case 'expired':
      return 'danger';
    default:
      return 'default';
  }
}

export function subscriptionStatusLabel(status: string, planExpiredAt: string | null): string {
  if (status === 'expired' && planExpiredAt) {
    return `expired ${format(new Date(planExpiredAt), 'MMM d, yyyy')}`;
  }
  return status;
}
